/**
 * The run counts the introduction teaches, and how each is written.
 *
 * The COLORS are the table's own map, `RUN_VARIANT` in
 * UserActions/MultiRunActions/runVariants.ts (EN-663 AC-5.2: 1X the Check
 * blue, 2X the Call green, 3X the Raise orange). The modal reads that map
 * directly rather than a copy, so the introduction cannot teach a color the
 * felt does not use.
 */
export const RUN_COUNTS = [1, 2, 3] as const;

export type RunCount = (typeof RUN_COUNTS)[number];

/** The on-screen label, in AC-5.2's casing. */
export const runItLabel = (count: RunCount): string => `RUN IT ${count}X`;

/** What a screen reader says instead ("2X" reads aloud as "two ex"). */
export const runItSpokenLabel = (count: RunCount): string =>
  `Run it ${count} ${count === 1 ? 'time' : 'times'}`;
